export class TimeSpan implements TimeSpan {
    private static readonly nanosecondsPerTick: number = 100;
    private static readonly ticksPerMicrosecond: number = 10;
    private static readonly ticksPerMillisecond: number = this.ticksPerMicrosecond * 1000;
    private static readonly ticksPerSecond: number = this.ticksPerMillisecond * 1000;   // 10,000,000
    private static readonly ticksPerMinute: number = this.ticksPerSecond * 60;         // 600,000,000
    private static readonly ticksPerHour: number = this.ticksPerMinute * 60;        // 36,000,000,000
    private static readonly ticksPerDay: number = this.ticksPerHour * 24;          // 864,000,000,000
    
    constructor(ticks: number = 0) {
        this.ticks = ticks;
    }

    public ticks: number = 0;
    public nanoseconds?: number = ((this.ticks % TimeSpan.ticksPerMicrosecond) * 100);
    public microseconds?: number = ((this.ticks / TimeSpan.ticksPerMicrosecond) % 1000);
    public milliseconds?: number = ((this.ticks / TimeSpan.ticksPerMillisecond) % 1000);
    public seconds?: number = ((this.ticks / TimeSpan.ticksPerSecond) % 60);
    public minutes?: number = ((this.ticks / TimeSpan.ticksPerMinute) % 60);
    public hours?: number = ((this.ticks / TimeSpan.ticksPerHour) % 24);
    public days?: number = (this.ticks / TimeSpan.ticksPerDay);

    public totalNanoseconds?: number = (this.ticks * TimeSpan.nanosecondsPerTick);
    public totalMicroseconds?: number = (this.ticks / TimeSpan.ticksPerMicrosecond);
    public totalMilliseconds?: number = (this.ticks / TimeSpan.ticksPerMillisecond);
    public totalSeconds?: number = (this.ticks / TimeSpan.ticksPerSecond);
    public totalMinutes?: number = (this.ticks / TimeSpan.ticksPerMinute);
    public totalHours?: number = (this.ticks / TimeSpan.ticksPerHour);
    public totalDays?: number = (this.ticks / TimeSpan.ticksPerDay);
        
    private static Interval(value: number, scale: number): TimeSpan {
        return new TimeSpan(value * scale);
    }

    public static FromMicroseconds(value: number): TimeSpan {
        return TimeSpan.Interval(value, this.ticksPerMicrosecond);
    }

    public static FromMilliseconds(value: number): TimeSpan {
        return TimeSpan.Interval(value, this.ticksPerMillisecond);
    }

    public static FromSeconds(value: number): TimeSpan {
        return TimeSpan.Interval(value, this.ticksPerSecond);
    }

    public static FromMinutes(value: number): TimeSpan {
        return TimeSpan.Interval(value, this.ticksPerMinute);
    }

    public static FromHours(value: number): TimeSpan {
        return TimeSpan.Interval(value, this.ticksPerHour);
    }

    public static FromDays(value: number): TimeSpan {
        return TimeSpan.Interval(value, this.ticksPerDay);
    }
}